import { render } from "./AtualizarAtendimentoDetalhe.vue?vue&type=template&id=685ef1d9"
import script from "./AtualizarAtendimentoDetalhe.vue?vue&type=script&lang=js"
export * from "./AtualizarAtendimentoDetalhe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__